import { IAreaDimension } from '../data/dimension/dimension';
import { EEntityType } from '../types';
import { AreaDimensionTextInfo, AreaDimensionTextInfoModel } from './2d/textInfo';
import BaseEntity from './BaseEntity';
import { globalStores } from '@/editor/stores';

export class AreaDimensionTextInfoEntity extends BaseEntity<EEntityType.TextInfo> {
  private _data: IAreaDimension;
  private _label: AreaDimensionTextInfo;
  protected override _model2d: AreaDimensionTextInfoModel;

  constructor(data: IAreaDimension) {
    super({ type: EEntityType.TextInfo, id: data.id });
    this._data = data;
    this._label = new AreaDimensionTextInfo(data, {
      onDelete: () => globalStores.dimensionOperation.deleteAreaDimension(this.id)
    });
    this._model2d = new AreaDimensionTextInfoModel({
      labelEl: this._label.element,
      entityId: this.id
    });
  }

  getData() {
    return this._data;
  }

  override update(data: IAreaDimension) {
    this._data = data;
    this._label.update(data);
    this._model2d.update();
  }

  updatePosition() {
    this._label.updatePosition();
    this._model2d.update();
  }

  setVisible(visible: boolean) {
    this._model2d.setVisible(visible);
    this._label.setVisible(visible);
  }

  setSelected(selected: boolean) {
    this._selected = selected;
    this._label.setSelected(selected);
  }

  setHover(hover: boolean) {
    this._label.setHover(hover);
  }

  override dispose(): void {
    super.dispose();
    this._label.dispose();
  }
}
